import { BlueprintsVM } from './blueprints.viewmodel';
import { BlueprintsContext, connectedBlueprintsVM } from './blueprints.context';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { BlueprintsPresentation, BlueprintsPresentationProps } from './blueprints.presentation';

const BlueprintsContainer = connectedBlueprintsVM<BlueprintsPresentationProps>(BlueprintsPresentation, vm => ({ vm: vm }));

export const Blueprints = moduleHost(BlueprintsVM, BlueprintsContext, BlueprintsContainer);
